<div class="container-fluid pt-3">
	<div class="float-end" *ngIf="shouldOpenStudy()">
        <button type="button" class="btn btn-info" jhiTranslate="study.details.actions.open-study" (click)="openStudyNew(studyDetails)"
                *jhiHasAnyAuthority="STUDIES_EDITION_PERMISSIONS">Open</button>
	</div>
	<jhi-collapsible heading="{{translateService.instant('study.details.basic-details.title')}}" img="content/img/basic-details.png">
		<div class="container-fluid mb-2">
            <div class="row pb-3">
                <div class="col align-items-start">
                    <label class="col-12 fw-bold" jhiTranslate="study.details.basic-details.study-name">Study Name:</label>
                    <span class="col-12 value-chip-light mt-2 text-wrap"><truncate-span [textInput]="studyDetails?.name" [maxLength]="255" [showCopyButton]="true"></truncate-span></span>
                </div>
                <div class="col align-items-start">
                    <label class="col-12 fw-bold" jhiTranslate="study.details.basic-details.created-by">Created By:</label>
                    <span class="col-12 value-chip-light mt-2" title="{{studyDetails?.createdByName}}">{{studyDetails?.createdByName}}</span>
                </div>
                <div class="col align-items-start">
                    <label class="col-12 fw-bold" jhiTranslate="study.details.basic-details.number-of-entries">No. of Entries:</label>
                    <span class="col-12 value-chip-light mt-2">{{studyDetails?.numberOfEntries}}</span>&nbsp;
                </div>
                <div class="col align-items-start">
                    <label class="col-12 fw-bold" jhiTranslate="study.details.basic-details.number-of-plots"># of Plots:</label>
                    <span class="col-12 value-chip-light mt-2">{{studyDetails?.numberOfPlots}}</span>
                </div>
            </div>
            <div class="row pb-3">
                <div class="col align-items-start">
                    <label class="col-12 fw-bold" jhiTranslate="study.details.basic-details.description">Description:</label>
                    <span class="col-12 value-chip-light mt-2 text-wrap"><truncate-span [textInput]="studyDetails?.description" [maxLength]="255"></truncate-span></span>
                </div>
                <div class="col align-items-start">
                    <label class="col-12 fw-bold" jhiTranslate="study.details.basic-details.last-updated">Last Updated:</label>
                    <span class="col-12 value-chip-light mt-2">{{studyDetails?.lastUpdateDate || '-'}}</span>
                </div>
                <div class="col align-items-start">
                    <label class="col-12 fw-bold" jhiTranslate="study.details.basic-details.field-map-created">Field Map Created:</label>
                    <span class="col-12 value-chip-light mt-2">{{studyDetails?.hasFieldLayout ? 'Yes' : 'No'}}</span>
                </div>
                <div class="col align-items-start">
                    <label class="col-12 fw-bold" jhiTranslate="study.details.basic-details.study-type">Study Type:</label>
                    <span class="col-12 value-chip-light mt-2">{{ getStudyType(studyDetails?.studyType) | translate }}</span>
                </div>
            </div>
            <div class="row pb-3">
                <div class="col align-items-start">
                    <label class="col-12 fw-bold" jhiTranslate="study.details.basic-details.creation-date">Creation Date:</label>
                    <span class="col-12 value-chip-light mt-2">{{studyDetails?.startDate}}</span>
                </div>
                <div class="col align-items-start">
                    <label class="col-12 fw-bold" jhiTranslate="study.details.basic-details.number-of-variates-with-data"># of Variates with Data:</label>
                    <span class="col-12 value-chip-light mt-2">{{studyDetails?.numberOfVariablesWithData}}&nbsp;
                    <span jhiTranslate="study.details.basic-details.of"></span>&nbsp;
                        {{studyDetails?.totalVariablesWithData}}</span>
                </div>
                <div class="col align-items-start">
                    <label class="col-12 fw-bold" jhiTranslate="study.details.basic-details.objective">Objective:</label>
                    <span class="col-12 value-chip-light mt-2  text-wrap"><truncate-span [textInput]="studyDetails?.objective || '-'" [maxLength]="255"></truncate-span></span>
                </div>
                <div class="col align-items-start">
                    <label class="col-12 fw-bold" jhiTranslate="study.details.basic-details.completion-date">Completion Date:</label>
                    <span class="col-12 value-chip-light mt-2">{{studyDetails?.endDate || '-'}}</span>
                </div>
            </div>
		</div>
	</jhi-collapsible>

    <jhi-collapsible heading="{{translateService.instant('study.details.study-settings.title')}}" [isCollapsed]="true" iconClass="bms-icon bms-mgt-details">
        <div class="container-fluid mb-2">
            <ng-container *ngIf="studyDetails?.studySettings.length; else studySettingsNoData">
                <ng-container *ngFor="let studySetting of studyDetails?.studySettings; index as i">
                    <div *ngIf="i % 4 === 0" class="row pb-3">
                        <div class="col align-items-start pb-3">
                            <label class="col-12 fw-bold">{{ observationVariableHelperService.getVariableDisplayName(studyDetails.studySettings[i]) }}:</label>
                            <span class="col-12 value-chip-light mt-2">{{ observationVariableHelperService.getVariableValueFromVariable(studyDetails.studySettings[i])?.toString().trim() || '-' }}</span>
                        </div>
                        <div *ngIf="studyDetails.studySettings[i + 1]" class="col align-items-start pb-3">
                            <label class="col-12 fw-bold">{{ observationVariableHelperService.getVariableDisplayName(studyDetails.studySettings[i + 1]) }}:</label>
                            <span class="col-12 value-chip-light mt-2">{{ observationVariableHelperService.getVariableValueFromVariable(studyDetails.studySettings[i + 1])?.toString().trim() || '-' }}</span>
                        </div>
                        <div *ngIf="studyDetails.studySettings[i + 2]" class="col align-items-start pb-3">
                            <label class="col-12 fw-bold">{{ observationVariableHelperService.getVariableDisplayName(studyDetails.studySettings[i + 2]) }}:</label>
                            <span class="col-12 value-chip-light mt-2">{{ observationVariableHelperService.getVariableValueFromVariable(studyDetails.studySettings[i + 2])?.toString().trim() || '-' }}</span>
                        </div>
                        <div *ngIf="studyDetails.studySettings[i + 3]" class="col align-items-start pb-3">
                            <label class="col-12 fw-bold">{{ observationVariableHelperService.getVariableDisplayName(studyDetails.studySettings[i + 3]) }}:</label>
                            <span class="col-12 value-chip-light mt-2">{{ observationVariableHelperService.getVariableValueFromVariable(studyDetails.studySettings[i + 3])?.toString().trim() || '-' }}</span>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-template #studySettingsNoData>
                <span jhiTranslate="study.details.study-settings.no-data"></span>
            </ng-template>
        </div>
    </jhi-collapsible>

	<jhi-collapsible heading="{{translateService.instant('study.details.selections.title')}}" [isCollapsed]="true" iconClass="bms-icon bms-variates">
		<div class="container-fluid mb-2">
			<div class="row">
				<div class="col-6">
					<table class="table table-striped table-bordered table-curved" *ngIf="studyDetails?.selections.length else selectionsNoData">
						<thead>
						<tr>
							<th><span jhiTranslate="study.details.table.name"></span></th>
							<th><span jhiTranslate="study.details.table.description"></span></th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let selection of studyDetails.selections">
							<td><a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
								   [queryParams]="{ variableId: selection.termId }">{{ observationVariableHelperService.getVariableDisplayName(selection) }}</a></td>
							<td>{{selection.description}}</td>
						</tr>
						</tbody>
					</table>
					<ng-template #selectionsNoData>
						<span jhiTranslate="study.details.selections.no-data"></span>
					</ng-template>
				</div>
			</div>
		</div>
	</jhi-collapsible>

	<jhi-collapsible heading="{{translateService.instant('study.details.entry-details.title')}}" [isCollapsed]="true" iconClass="bms-icon bms-factors">
		<div class="container-fluid mb-2">
			<div class="row">
				<div class="col-6">
					<table class="table table-striped table-bordered table-curved" *ngIf="studyDetails?.entryDetails.length else entryDetailsNoData">
						<thead>
						<tr>
							<th><span jhiTranslate="study.details.table.name"></span></th>
							<th><span jhiTranslate="study.details.table.description"></span></th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let entryDetail of studyDetails.entryDetails">
							<td><a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
								   [queryParams]="{ variableId: entryDetail.termId }">{{ observationVariableHelperService.getVariableDisplayName(entryDetail) }}</a></td>
							<td>{{entryDetail.description}}</td>
						</tr>
						</tbody>
					</table>
					<ng-template #entryDetailsNoData>
						<span jhiTranslate="study.details.entry-details.no-data"></span>
					</ng-template>
				</div>
			</div>
		</div>
	</jhi-collapsible>

	<jhi-collapsible heading="{{translateService.instant('study.details.treatment-factors.title')}}" [isCollapsed]="true" iconClass="bms-icon bms-treatment-factors">
		<div class="container-fluid mb-2">
			<div class="row">
				<div class="col-6">
					<table class="table table-striped table-bordered table-curved" *ngIf="studyDetails?.treatmentFactors.length else treatmentFactorsNoData">
						<thead>
						<tr>
							<th><span jhiTranslate="study.details.treatment-factors.table.treatment"></span></th>
							<th><span jhiTranslate="study.details.treatment-factors.table.number-of-treatments"></span></th>
							<th><span jhiTranslate="study.details.treatment-factors.table.label"></span></th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let treatmentFactor of studyDetails.treatmentFactors">
							<td><a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
								   [queryParams]="{ variableId: treatmentFactor.levelVariable.termId }">{{ observationVariableHelperService.getVariableDisplayName(treatmentFactor.levelVariable) }}</a></td>
							<td>{{treatmentFactor.values != null ? treatmentFactor.values.length : 0}}</td>
							<td>{{treatmentFactor.valueVariable.name}}</td>
						</tr>
						</tbody>
					</table>
					<ng-template #treatmentFactorsNoData>
						<span jhiTranslate="study.details.treatment-factors.no-data"></span>
					</ng-template>
				</div>
			</div>
		</div>
	</jhi-collapsible>

	<jhi-collapsible heading="{{translateService.instant('study.details.environments.title')}}" [isCollapsed]="false" iconClass="bms-icon bms-environments">
		<div class="container-fluid mb-2">
			<div class="row">
				<div class="col-6">
					<h5 jhiTranslate="study.details.environments.details.title">ENVIRONMENT DETAILS</h5>
					<table class="table table-striped table-bordered table-curved" *ngIf="studyDetails?.environmentDetails?.length > 0 else environmentDetailsNoData">
						<thead>
						<tr>
							<th><span jhiTranslate="study.details.table.name"></span></th>
							<th><span jhiTranslate="study.details.table.description"></span></th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let environmentDetail of studyDetails.environmentDetails">
							<td><a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
								   [queryParams]="{ variableId: environmentDetail.termId }">{{ observationVariableHelperService.getVariableDisplayName(environmentDetail) }}</a></td>
							<td>{{environmentDetail.description}}</td>
						</tr>
						</tbody>
					</table>
				</div>
				<ng-template #environmentDetailsNoData>
					<span jhiTranslate="study.details.environments.conditions.no-data"></span>
				</ng-template>

				<div class="col-6">
					<h5 jhiTranslate="study.details.environments.conditions.title">ENVIRONMENT CONDITIONS</h5>
					<table class="table table-striped table-bordered table-curved" *ngIf="studyDetails?.environmentConditions?.length > 0 else environmentConditionsNoData">
						<thead>
						<tr>
							<th><span jhiTranslate="study.details.table.name"></span></th>
							<th><span jhiTranslate="study.details.table.description"></span></th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let environmentCondition of studyDetails.environmentConditions">
							<td><a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
								   [queryParams]="{ variableId: environmentCondition.termId }">{{ observationVariableHelperService.getVariableDisplayName(environmentCondition) }}</a></td>
							<td>{{environmentCondition.description}}</td>
						</tr>
						</tbody>
					</table>
				</div>
				<ng-template #environmentConditionsNoData>
					<span jhiTranslate="study.details.environments.conditions.no-data"></span>
				</ng-template>
			</div>
		</div>
	</jhi-collapsible>

	<jhi-collapsible heading="{{translateService.instant('study.details.experimental-design.title')}}" [isCollapsed]="true" iconClass="bms-icon bms-exp-design">
		<div class="container-fluid mb-2">
			<div class="row" *ngIf="studyDetails?.experimentalDesignDetail else experimentalDesignNoData">
				<div class="col-6">
					<div class="row pb-2">
                        <div class="col">
                            <label class="h5" jhiTranslate="study.details.experimental-design.design-parameters.title">Design Parameters:</label>&nbsp;
                        </div>
					</div>
					<div class="row pb-2">
                        <div class="col">
                            <label class="fw-bold" jhiTranslate="study.details.experimental-design.design-parameters.design-type">Design Type:</label>&nbsp;
                            <span class="value-chip-light">{{ getExperimentalDesignName(studyDetails) | translate}}</span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.experimentalDesignDetail.replicationPercentage">
                        <div class="col">
                            <label class="fw-bold" jhiTranslate="study.details.experimental-design.design-parameters.replication-percentage">% of test entries to replicate:</label>&nbsp;
                            <span class="value-chip-light">{{studyDetails?.experimentalDesignDetail.replicationPercentage.value}}</span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.experimentalDesignDetail.numberOfReplicates">
                        <div class="col">
                            <label class="fw-bold" jhiTranslate="study.details.experimental-design.design-parameters.number-of-replications">Number of replications:</label>&nbsp;
                            <span class="value-chip-light">{{studyDetails?.experimentalDesignDetail.numberOfReplicates.value}}</span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.experimentalDesignDetail.numberOfBlocks">
                        <div class="col">
                            <label class="fw-bold" jhiTranslate="study.details.experimental-design.design-parameters.number-of-blocks">Number of blocks per Replication:</label>&nbsp;
                            <span class="value-chip-light">{{studyDetails?.experimentalDesignDetail.numberOfBlocks.value}}</span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.experimentalDesignDetail.blockSize">
                        <div class="col">
                            <label class="fw-bold" jhiTranslate="study.details.experimental-design.design-parameters.block-size">Block size:</label>&nbsp;
                            <span class="value-chip-light">{{studyDetails?.experimentalDesignDetail.blockSize.value}}</span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.experimentalDesignDetail.numberOfRowsInReps">
                        <div class="col">
                            <label class="fw-bold" jhiTranslate="study.details.experimental-design.design-parameters.rows-in-reps">Number of rows in replications:</label>&nbsp;
                            <span class="value-chip-light">{{studyDetails?.experimentalDesignDetail.numberOfRowsInReps.value}}</span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.experimentalDesignDetail.numberOfColsInReps">
                        <div class="col">
                            <label class="fw-bold" jhiTranslate="study.details.experimental-design.design-parameters.cols-in-reps">Number of columns in replications:</label>&nbsp;
                            <span class="value-chip-light">{{studyDetails?.experimentalDesignDetail.numberOfColsInReps.value}}</span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.experimentalDesignDetail.replicationsMap">
                        <div class="col">
                            <label class="fw-bold" jhiTranslate="study.details.experimental-design.design-parameters.replication-arrangement">How are the replications to be arranged in the field?</label>&nbsp;
                            <span class="value-chip-light">{{studyDetails?.experimentalDesignDetail.replicationsMapDisplay}}</span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.experimentalDesignDetail.numberOfRepsInCols">
                        <div class="col">
						    <label class="fw-bold" jhiTranslate="study.details.experimental-design.design-parameters.reps-in-column">Number of reps in each column, running from left to right:</label>&nbsp;
                            <span class="value-chip-light">{{studyDetails?.experimentalDesignDetail.numberOfRepsInCols.value}}</span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.experimentalDesignDetail.numberOfContiguousBlocksLatinize">
                        <div class="col">
                            <label class="fw-bold" jhiTranslate="study.details.experimental-design.design-parameters.number-contiguous-blocks-latinize">Number of contiguous blocks to latinize:</label>&nbsp;
                            <span class="value-chip-light">{{studyDetails?.experimentalDesignDetail.numberOfContiguousBlocksLatinize.value}}</span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.experimentalDesignDetail.numberOfContiguousRowsLatinize">
                        <div class="col">
						<label class="fw-bold" jhiTranslate="study.details.experimental-design.design-parameters.number-contiguous-rows-latinize">Number of contiguous rows to latinize:</label>&nbsp;
                            <span class="value-chip-light">{{studyDetails?.experimentalDesignDetail.numberOfContiguousRowsLatinize.value}}</span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.experimentalDesignDetail.numberOfContiguousColsLatinize">
                        <div class="col">
						<label class="fw-bold" jhiTranslate="study.details.experimental-design.design-parameters.number-contiguous-cols-latinize">Number of contiguous columns to latinize:</label>&nbsp;
                            <span class="value-chip-light">{{studyDetails?.experimentalDesignDetail.numberOfContiguousColsLatinize.value}}</span>
                        </div>
					</div>
				</div>
				<div class="col-6">
					<div class="row pb-2">
                        <div class="col">
						<label class="h5" jhiTranslate="study.details.experimental-design.summary.title">Summary of Design Details:</label>&nbsp;
                        </div>
					</div>
					<div class="row pb-2">
                        <div class="col">
						<label class="fw-bold" jhiTranslate="study.details.experimental-design.summary.number-of-environments">Number of environments:</label>&nbsp;
                            <span class="value-chip-light">{{studyDetails?.numberOfEnvironments}}</span>
                        </div>
					</div>
					<div class="row pb-2">
                        <div class="col">
						<label class="fw-bold" jhiTranslate="study.details.experimental-design.summary.number-of-treatments">Number of treatments:</label>&nbsp;
                            <span class="value-chip-light">{{studyDetails?.numberOfEntries}}</span>
                        </div>
					</div>
					<ng-container *ngIf="studyDetails?.experimentalDesignDetail.experimentalDesign.value === '10164'">
						<div class="row pb-2">
                            <div class="col">
							<label class="fw-bold" jhiTranslate="study.details.experimental-design.summary.number-of-test-entries">Number of Test entries:</label>&nbsp;
                                <span class="value-chip-light">{{studyDetails?.numberOfEntries - studyDetails?.numberOfChecks}}</span>
                            </div>
						</div>
						<div class="row pb-2">
                            <div class="col">
							<label class="fw-bold" jhiTranslate="study.details.experimental-design.summary.number-of-check-entries">Number of Check entries:</label>&nbsp;
                                <span class="value-chip-light">{{studyDetails?.numberOfChecks}}</span>
                            </div>
						</div>
						<div class="row pb-2">
                            <div class="col">
							<label class="fw-bold" jhiTranslate="study.details.experimental-design.summary.number-of-non-replicated-entries">Number of Non Replicated entries:</label>&nbsp;
                                <span class="value-chip-light">{{studyDetails?.nonReplicatedEntriesCount}}</span>
                            </div>
						</div>
						<div class="row pb-2" *ngIf="studyDetails?.numberOfEnvironments && studyDetails?.experimentalDesignDetail.blockSize">
                            <div class="col">
							<label class="fw-bold" jhiTranslate="study.details.experimental-design.summary.number-of-entries-per-block">Number of entries per block:</label>&nbsp;
                                <span class="value-chip-light">{{getPlotSize() / asNumber(studyDetails?.experimentalDesignDetail.blockSize.value)}}</span>
                            </div>
						</div>
						<div class="row pb-2" *ngIf="studyDetails?.numberOfEnvironments">
                            <div class="col">
							<label class="fw-bold" jhiTranslate="study.details.experimental-design.summary.number-of-plots">Total number of plots:</label>&nbsp;
                                <span class="value-chip-light">{{getPlotSize()}}</span>
                            </div>
						</div>
					</ng-container>
					<div class="row pb-2" *ngIf="studyDetails?.experimentalDesignDetail.experimentalDesign.value !== '10164' &&
						studyDetails?.numberOfEnvironments &&
						studyDetails?.experimentalDesignDetail.blockSize">
                        <div class="col">
						<label class="fw-bold" jhiTranslate="study.details.experimental-design.summary.number-of-blocks">Number of blocks per Replication:</label>&nbsp;
                            <span class="value-chip-light">{{studyDetails?.numberOfEntries / asNumber(studyDetails?.experimentalDesignDetail.blockSize.value)}}</span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.factorsByIds[8230]">
                        <div class="col">
						<label class="fw-bold" jhiTranslate="study.details.experimental-design.summary.treatment-factor">Treatment Factor:</label>&nbsp;
                            <span class="value-chip-light"><a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                                              [queryParams]="{ variableId: studyDetails?.factorsByIds[8230].termId }">{{ observationVariableHelperService.getVariableDisplayName(studyDetails?.factorsByIds[8230]) }}</a></span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.factorsByIds[8210]">
                        <div class="col">
						<label class="fw-bold" jhiTranslate="study.details.experimental-design.summary.replicate-factor">Replicate Factor:</label>&nbsp;
                            <span class="value-chip-light"><a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                                              [queryParams]="{ variableId: studyDetails?.factorsByIds[8210].termId }">{{ observationVariableHelperService.getVariableDisplayName(studyDetails?.factorsByIds[8210]) }}</a></span>
                        </div>
                    </div>
					<div class="row pb-2" *ngIf="studyDetails?.factorsByIds[8220]">
                        <div class="col">
						<label class="fw-bold" jhiTranslate="study.details.experimental-design.summary.block-factor">Block Factor:</label>&nbsp;
                            <span class="value-chip-light"><a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                                              [queryParams]="{ variableId: studyDetails?.factorsByIds[8220].termId }">{{ observationVariableHelperService.getVariableDisplayName(studyDetails?.factorsByIds[8220]) }}</a></span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.factorsByIds[8200]">
                        <div class="col">
						<label class="fw-bold" jhiTranslate="study.details.experimental-design.summary.plot-factor">Plot Factor:</label>&nbsp;
                            <span class="value-chip-light"><a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                                              [queryParams]="{ variableId: studyDetails?.factorsByIds[8200].termId }">{{ observationVariableHelperService.getVariableDisplayName(studyDetails?.factorsByIds[8200]) }}</a></span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.factorsByIds[8581]">
                        <div class="col">
						<label class="fw-bold" jhiTranslate="study.details.experimental-design.summary.row-factor">Row Factor:</label>&nbsp;
                            <span class="value-chip-light"><a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                                              [queryParams]="{ variableId: studyDetails?.factorsByIds[8581].termId }">{{ observationVariableHelperService.getVariableDisplayName(studyDetails?.factorsByIds[8581]) }}</a></span>
                        </div>
					</div>
					<div class="row pb-2" *ngIf="studyDetails?.factorsByIds[8582]">
                        <div class="col">
						<label class="fw-bold" jhiTranslate="study.details.experimental-design.summary.column-factor">Column Factor:</label>&nbsp;
                            <span class="value-chip-light"><a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                                              [queryParams]="{ variableId: studyDetails?.factorsByIds[8582].termId }">{{ observationVariableHelperService.getVariableDisplayName(studyDetails?.factorsByIds[8582]) }}</a></span>
                    </div>
					</div>
				</div>
			</div>
			<ng-template #experimentalDesignNoData>
				<span jhiTranslate="study.details.experimental-design.no-data"></span>
			</ng-template>
		</div>
	</jhi-collapsible>

	<jhi-collapsible heading="{{translateService.instant('study.details.datasets.title')}}" img="content/img/matching-nurseries.png">
		<div class="container-fluid mb-2 ps-0">
			<div class="row ps-3">
				<div>
					<label class="fw-bold" jhiTranslate="study.details.datasets.select-dataset">Choose a dataset to open:</label>&nbsp;
				</div>
				<div class="col-4 pt-2">
					<ng-select [items]="datasets" [(ngModel)]="selectedDatasetId"
							   bindValue="datasetId" bindLabel="name"
							   [searchFn]="searchDataset"
							   (change)="onDatasetSelected()"
							   [dropdownPosition]="'bottom'">
						<ng-template ng-option-tmp let-dataset="item">
							<div title="{{dataset.name}}">{{dataset.name}}</div>
						</ng-template>
					</ng-select>
				</div>
			</div>
			<nav class="mt-4" *ngIf="datasetTabs.length > 0">
				<ul class="nav nav-tabs">
					<li class="nav-item pe-1" *ngFor="let tab of datasetTabs" role="presentation">
						<a class="nav-link pb-0" role="tab" data-bs-toggle="tab" (click)="setActive(tab.id)"
						   [routerLink]="['study/' + studyId + '/summary/dataset/' + tab.id]" [class.active]="tab.active"
						   [queryParams]="{ studyId: studyId, datasetId: tab.id, datasetName: tab.name }">
							<span class="tab-text-ellipsis" title="{{tab.name}}">{{tab.name}}</span>
							<i class="fa fa-times close-nav-tab nav-tab-text-ellipsis" (click)="closeTab(tab)"></i>
						</a>
					</li>
				</ul>
				<div class="tab-content">
					<!-- Tab panes -->
					<div *ngFor="let tab of datasetTabs; trackBy: trackId" role="tabpanel" class="tab-pane container-fluid row" [class.active]="tab.active" id="dataset-{{tab.id}}">
						<div class="col-xs-12 col-md-12">
							<jhi-study-summary-dataset [studyId]="studyId" [datasetId]="tab.id" [datasetType]="getDatasetTypeByDatasetId(tab.id)"></jhi-study-summary-dataset>
						</div>
					</div>
				</div>
			</nav>
		</div>
	</jhi-collapsible>

</div>
